export default __webpack_public_path__ + "static/media/survey-junkie-logo.7e2e0004.png";